import BaseModel from "./BaseModel";
import { useContextStore } from "@/stores/context";
import { capitalizeWords } from "@/composables/textUtils";

/**
 * Category
 */
export default class Language extends BaseModel{

  constructor({
    id,
    name,
    code,
    en,
    pt,
    es,
    total
  }) {
    super();

    this.id = id || null;
    this.name = name || null;
    this.code = code || null;
    this.en = en || null;
    this.pt = pt || null;
    this.es = es || null;
    this.total = total || 0;
  }

  /**
   * Gets translated language name
   * @param {Bool} translated - to return name translated
   * @returns {String}
   */
  getName(translated = true, capitalize = false) {
    if (translated) {
      const contextStore = useContextStore();
      const translatedName = this[contextStore.getLang] != null ? this[contextStore.getLang] : this.en;
      return capitalize ? capitalizeWords(translatedName) : translatedName;
    }
    return capitalize ? capitalizeWords(this.name) : this.name;
  }
}